import React, { useState } from "react";
import axios from "axios";
import { useAuth } from "../../../contexts/AuthContext";

function GetBalanceEquity() {
  const { apiBaseUrl } = useAuth();
  const [target, setTarget] = useState("groups");
  const [responseData, setResponseData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const fetchBalanceEquity = async () => {
    try {
      setLoading(true);
      setMessage("");

      const response = await axios.post(
        `${apiBaseUrl}/api/admin/final/accounts/balance`,
        { target },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      setResponseData(response.data);
      setMessage("اطلاعات با موفقیت دریافت شد");
    } catch (error) {
      console.error("❌ خطا در دریافت Balance & Equity:", error);
      setMessage(error.response?.data?.message || "خطا در دریافت اطلاعات");
      if (error.response) {
      }
    } finally {
      setLoading(false);
    }
  };

  const accountsData = responseData?.data?.data?.tracked_accounts || [];
  const summary = responseData?.data?.data?.summary || null;

  return (
    <div className="space-y-6 p-6">
      <div className="bg-blue-900/20 border border-blue-600 rounded-lg p-4 mb-6">
        <h3 className="text-xl font-semibold text-white mb-2 flex items-center gap-2">
          <span>💰</span> دریافت Balance & Equity
        </h3>
        <p className="text-blue-300 text-sm">
          مشاهده موجودی و اطلاعات مالی حساب‌ها
        </p>
      </div>

      {message && (
        <div
          className={`p-4 rounded-lg text-center ${
            message.includes("موفقیت")
              ? "bg-green-900 border border-green-600 text-green-400"
              : "bg-red-900 border border-red-600 text-red-400"
          }`}
        >
          {message}
        </div>
      )}

      {/* Target Selection */}
      <div className="bg-gray-800 border border-gray-600 rounded-lg p-4">
        <label className="block text-white font-medium mb-3">
          انتخاب نوع حساب (Target):
        </label>
        <div className="flex gap-4">
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="radio"
              name="target"
              value="individuals"
              checked={target === "individuals"}
              onChange={(e) => setTarget(e.target.value)}
              className="w-5 h-5 accent-blue-600"
            />
            <span className="text-white">Individuals (حساب‌های فردی)</span>
          </label>
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="radio"
              name="target"
              value="groups"
              checked={target === "groups"}
              onChange={(e) => setTarget(e.target.value)}
              className="w-5 h-5 accent-blue-600"
            />
            <span className="text-white">Groups (گروه‌ها)</span>
          </label>
        </div>
      </div>

      {/* Fetch Button */}
      <button
        onClick={fetchBalanceEquity}
        disabled={loading}
        className="w-full py-4 px-6 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-600 text-white font-bold text-lg rounded-lg transition duration-200 flex items-center justify-center gap-3 shadow-lg"
      >
        {loading ? (
          <>
            <div className="animate-spin rounded-full h-6 w-6 border-3 border-white border-t-transparent"></div>
            در حال دریافت...
          </>
        ) : (
          <>
            <span>💰</span>
            دریافت Balance & Equity
          </>
        )}
      </button>

      {/* Summary Cards */}
      {summary && (
        <div className="bg-gradient-to-r from-purple-900 to-blue-900 border border-purple-600 rounded-lg p-6">
          <h4 className="text-white font-bold text-lg mb-4 flex items-center gap-2">
            <span>📊</span> خلاصه کلی
          </h4>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
            <div className="bg-black/30 rounded-lg p-3">
              <p className="text-gray-300 text-xs mb-1">تعداد کل حساب‌ها:</p>
              <p className="text-white font-bold text-xl">
                {summary.total_tracked_accounts}
              </p>
            </div>
            <div className="bg-black/30 rounded-lg p-3">
              <p className="text-gray-300 text-xs mb-1">مجموع Balance:</p>
              <p className="text-green-400 font-bold text-lg">
                $
                {parseFloat(summary.total_balance_all_tracked).toLocaleString()}
              </p>
            </div>
            <div className="bg-black/30 rounded-lg p-3">
              <p className="text-gray-300 text-xs mb-1">مجموع Equity:</p>
              <p className="text-blue-400 font-bold text-lg">
                ${parseFloat(summary.total_equity_all_tracked).toLocaleString()}
              </p>
            </div>
            <div className="bg-black/30 rounded-lg p-3">
              <p className="text-gray-300 text-xs mb-1">معاملات فعال:</p>
              <p className="text-green-400 font-bold text-xl">
                {summary.trading_enabled_count}
              </p>
            </div>
            <div className="bg-black/30 rounded-lg p-3">
              <p className="text-gray-300 text-xs mb-1">معاملات غیرفعال:</p>
              <p className="text-red-400 font-bold text-xl">
                {summary.trading_disabled_count}
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Accounts List */}
      {accountsData.length > 0 && (
        <div className="space-y-4">
          <h4 className="text-white font-bold text-lg flex items-center gap-2">
            <span>📈</span> لیست حساب‌ها ({accountsData.length} مورد)
          </h4>

          {accountsData.map((account, index) => {
            const totalPnl = parseFloat(account.total_pnl);
            const dailyPnl = parseFloat(account.daily_pnl);

            return (
              <div
                key={index}
                className="bg-gray-800 border border-gray-600 rounded-lg p-5"
              >
                {/* Header */}
                <div className="flex justify-between items-start mb-4 pb-4 border-b border-gray-700">
                  <div>
                    <h5 className="text-white font-bold text-lg mb-1">
                      Login: {account.login}
                    </h5>
                    <div className="flex gap-2">
                      <span
                        className={`px-2 py-1 rounded text-xs font-bold ${
                          account.trading_enabled === "true"
                            ? "bg-green-600 text-white"
                            : "bg-red-600 text-white"
                        }`}
                      >
                        {account.trading_enabled === "true"
                          ? "Trading ON"
                          : "Trading OFF"}
                      </span>
                      <span
                        className={`px-2 py-1 rounded text-xs font-bold ${
                          account.is_tracked === "true"
                            ? "bg-blue-600 text-white"
                            : "bg-gray-600 text-white"
                        }`}
                      >
                        {account.is_tracked === "true"
                          ? "Tracked"
                          : "Not Tracked"}
                      </span>
                      <span className="px-2 py-1 rounded text-xs font-bold bg-purple-600 text-white">
                        {account.account_status_summary}
                      </span>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="text-gray-400 text-xs mb-1">Total P/L:</p>
                    <p
                      className={`text-2xl font-bold ${
                        totalPnl >= 0 ? "text-green-400" : "text-red-400"
                      }`}
                    >
                      ${totalPnl.toFixed(2)}
                    </p>
                    <p
                      className={`text-sm ${
                        totalPnl >= 0 ? "text-green-400" : "text-red-400"
                      }`}
                    >
                      ({parseFloat(account.total_pnl_percent).toFixed(2)}%)
                    </p>
                  </div>
                </div>

                {/* Main Stats */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
                  <div className="bg-gray-700/50 rounded p-3">
                    <p className="text-gray-400 text-xs mb-1">Balance:</p>
                    <p className="text-white font-bold text-lg">
                      ${parseFloat(account.balance).toLocaleString()}
                    </p>
                  </div>
                  <div className="bg-gray-700/50 rounded p-3">
                    <p className="text-gray-400 text-xs mb-1">Equity:</p>
                    <p className="text-white font-bold text-lg">
                      ${parseFloat(account.equity).toLocaleString()}
                    </p>
                  </div>
                  <div className="bg-gray-700/50 rounded p-3">
                    <p className="text-gray-400 text-xs mb-1">Margin:</p>
                    <p className="text-white font-bold text-lg">
                      ${parseFloat(account.margin).toLocaleString()}
                    </p>
                  </div>
                  <div className="bg-gray-700/50 rounded p-3">
                    <p className="text-gray-400 text-xs mb-1">Free Margin:</p>
                    <p className="text-white font-bold text-lg">
                      ${parseFloat(account.margin_free).toLocaleString()}
                    </p>
                  </div>
                </div>

                {/* Additional Info */}
                <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                  <div className="bg-gray-700/30 rounded p-2">
                    <p className="text-gray-400 text-xs">Daily P/L:</p>
                    <p
                      className={`font-bold ${
                        dailyPnl >= 0 ? "text-green-400" : "text-red-400"
                      }`}
                    >
                      ${dailyPnl.toFixed(2)}
                    </p>
                  </div>
                  <div className="bg-gray-700/30 rounded p-2">
                    <p className="text-gray-400 text-xs">Initial Balance:</p>
                    <p className="text-white font-bold">
                      $
                      {parseFloat(
                        account.initial_balance || 0
                      ).toLocaleString()}
                    </p>
                  </div>
                  <div className="bg-gray-700/30 rounded p-2">
                    <p className="text-gray-400 text-xs">Margin Level:</p>
                    <p className="text-white font-bold">
                      {parseFloat(account.margin_level).toFixed(2)}%
                    </p>
                  </div>
                  <div className="bg-gray-700/30 rounded p-2">
                    <p className="text-gray-400 text-xs">Active Positions:</p>
                    <p className="text-white font-bold">
                      {account.active_positions_count || "0"}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Raw JSON (Optional - for debugging) */}
      {responseData && (
        <details className="bg-gray-800 border border-gray-600 rounded-lg p-4">
          <summary className="text-white font-medium cursor-pointer hover:text-blue-400">
            نمایش JSON کامل (برای debugging)
          </summary>
          <pre className="bg-gray-900 p-4 rounded-lg text-gray-300 text-xs overflow-x-auto max-h-96 overflow-y-auto mt-3">
            {JSON.stringify(responseData, null, 2)}
          </pre>
        </details>
      )}
    </div>
  );
}

export default GetBalanceEquity;
